export enum CollapsibleListData_InitialExpandedItems {
  /** FIRST - First item will be expended initally */
  FIRST = 'FIRST',
  /** ALL - All items will expended initally */
  ALL = 'ALL',
  /** NONE - All items collapsed initally */
  NONE = 'NONE',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum CollapsibleListData_Direction {
  /** LTR - Left-to-right */
  LTR = 'LTR',
  /** RTL - Right-to-left */
  RTL = 'RTL',
  UNRECOGNIZED = 'UNRECOGNIZED',
}